import React from 'react';
import anybodyImg from 'assets/icon-anybody.png';

const AnyBodyImage = ({ large, width, height }: { large?: boolean, width?: number, height?: number }) => {
  if (large) return (
    <img className='AnyBodyImage' src={anybodyImg} style={{ width: width || '5.5rem', height: height || '5.5rem', borderRadius: '100%' }} />
  );
  return (
    <img className='AnyBodyImage' src={anybodyImg} style={{ width: width || '55px', height: height || '55px', borderRadius: 24 }} />
  );
};

export default AnyBodyImage;
